const getters = {
  userName: state => state.user.userName,
  editableTabsValue: state => state.user.editableTabsValue,
  editableTabs: state => state.user.editableTabs
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js